import type { CustomErrorRule } from '@/core/error/transport/types'
import { TmApiNumberAlreadyUseError } from '@/core/error/transport/tmApiNumberAlreadyUseError'

export const numberAlreadyUseErrorRule: CustomErrorRule = {
  subCodes: ['number.already_in_use'],
  klass: TmApiNumberAlreadyUseError,
}
